export const REGIONS = [
  {
    id: 'dk',
    flag: '/img/flags/007-denmark.svg',
  },
  {
    id: 'ch',
    flag: '/img/flags/003-switzerland.svg',
  },
  {
    id: 'de',
    flag: '/img/flags/002-germany.svg',
  },
  {
    id: 'en',
    flag: '/img/flags/001-united-kingdom.svg',
  },
  {
    id: 'se',
    flag: '/img/flags/004-sweden.svg',
  },
  {
    id: 'pt',
    flag: '/img/flags/006-portugal.svg',
  },
];
